const megaMenuItems = Array.from(
	document.querySelectorAll(".js-mega-menu-item"),
);
const megaMenu = document.querySelector(".js-header-nav");

// let isOpen = false;
let activeElement = undefined;

export function init() {
	document.addEventListener("keydown", onKeydown);
	document.addEventListener("click", onDocumentClick);

	megaMenuItems.forEach((item) => {
		item.addEventListener("click", function (event) {
			let targetId = item.getAttribute("data-target");

			if (!targetId) {
				return;
			}

			let targetElement = document.getElementById(targetId);

			if (!targetElement) {
				return;
			}

			if (activeElement && activeElement.id === targetId) {
				close(activeElement);
			} else {
				open(targetElement);
			}

			// subMenuItems.forEach(subItem => {
			// 	if (subItem.id == item.id) {
			// 		open(subItem);
			// 	}
			// });
		});
	});

	function open(element) {
		if (activeElement) {
			close(activeElement);
		}

		element.classList.add("is-active");
		element.setAttribute("aria-expanded", "true");

		activeElement = element;
	}

	function close(element) {
		if (!element) {
			return;
		}

		element.classList.remove("is-active");
		element.removeAttribute("aria-expanded");

		activeElement = undefined;
	}

	function onDocumentClick(event) {
		if (!megaMenu.contains(event.target)) {
			close(activeElement);
		}
	}

	function onKeydown(event) {
		if (event.key == "Escape") close(activeElement);
	}
}
